export const FETCH_USER_LOGOUT = 'FETCH_USER_LOGOUT';
export const FETCH_USER_LOGOUT_SUCCESS = 'FETCH_USER_LOGOUT_SUCCESS';
export const FETCH_USER_LOGOUT_FAILURE = 'FETCH_USER_LOGOUT_FAILURE';

export const CLOSE_LOGOUT_SNACKBAR = 'CLOSE_LOGOUT_SNACKBAR';